<template>
  <div class="pagination">
    <button 
      class="pagination-btn" 
      :class="{ disabled: !hasPrevPage }"
      :disabled="!hasPrevPage" 
      @click="$emit('page-change', currentPage - 1)"
    >
      <i class="fas fa-chevron-left"></i> Previous
    </button>
    
    <div class="pagination-info">
      <span class="current-page">{{ currentPage }}</span>
      <span class="separator">of</span>
      <span class="total-pages">{{ lastPage }}</span>
    </div>
    
    <button 
      class="pagination-btn" 
      :class="{ disabled: !hasNextPage }"
      :disabled="!hasNextPage" 
      @click="$emit('page-change', currentPage + 1)"
    >
      Next <i class="fas fa-chevron-right"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'DataPagination',
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    lastPage: {
      type: Number,
      required: true
    },
    hasNextPage: {
      type: Boolean,
      required: true
    },
    hasPrevPage: {
      type: Boolean,
      required: true
    }
  },
  emits: ['page-change']
}
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
  margin: 1.5rem 0;
}

.pagination-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1rem;
  background-color: white;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  color: #3498db;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.pagination-btn:hover:not(.disabled) {
  background-color: #f8f9fa;
  border-color: #3498db;
}

.pagination-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #495057;
  font-size: 0.875rem;
}

.current-page {
  font-weight: 600;
  color: #3498db;
  background-color: #f8f9fa;
  border-radius: 0.25rem;
  padding: 0.25rem 0.5rem;
  min-width: 1.5rem;
  text-align: center;
}

.separator {
  color: #6c757d;
}

.total-pages {
  font-weight: 500;
}

@media (max-width: 768px) {
  .pagination {
    gap: 0.75rem;
  }
  
  .pagination-btn {
    padding: 0.5rem 0.75rem;
    font-size: 0.75rem;
  }
}
</style> 